import React, { memo,useEffect } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import useProductCategory from "../../hooks/useProductCategory";

const CategoryListHome = () => {
    const {
        fetchProductCategory,
        data: productCategory,
        status: productCategoryStatus,
        error: productCategoryError,
    } = useProductCategory();

    useEffect(() => {
        fetchProductCategory();
    }, []);

    const chunk = (arr, size) => {
        const out = [];
        for (let i = 0; i < arr.length; i += size) {
            out.push(arr.slice(i, i + size));
        }
        return out;
    };


    console.log(productCategory)


    const StaticProductCategory=[
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/pakaianpria.webp",
        //     imageData:{url:"assets/images/brand_temp/pakaianpria.webp"} ,
        //     isActive: true,
        //     name: "Pakaian Pria"
        // },
        //  {
        //     id: "",
        //     image: "assets/images/brand_temp/6d63cca7351ba54a2e21c6be1721fa3a@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/6d63cca7351ba54a2e21c6be1721fa3a@resize_w320_nl.webp"},
        //     isActive: true, 
        //     name: "Pakaian Wanita"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/3c8ff51aab1692a80c5883972a679168@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/3c8ff51aab1692a80c5883972a679168@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Sepatu Pria"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/b98756cdb31eabe3d7664599e24ccc29@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/b98756cdb31eabe3d7664599e24ccc29@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Fashion Muslim"
        // }
        // ,
        // {
        //     id: "",
        //    image: "assets/images/brand_temp/47ed832eed0feb62fd28f08c9229440e@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/47ed832eed0feb62fd28f08c9229440e@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Tas Pria"
        // }
        // ,
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/9251edd6d6dd98855ff5a99497835d9c@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/9251edd6d6dd98855ff5a99497835d9c@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Fashion Bayi & Anak"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/1f18bdfe73df39c66e7326b0a3e08e87@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/1f18bdfe73df39c66e7326b0a3e08e87@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Aksesoris Fashion"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/4d1673a14c26c8361a76258d78446324@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/4d1673a14c26c8361a76258d78446324@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Ibu & Bayi"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/2bdf8cf99543342d4ebd8e1bdb576f80@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/2bdf8cf99543342d4ebd8e1bdb576f80@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Jam Tangan"
        // },
        // {
        //     id: "",
        //    image: "assets/images/brand_temp/id-50009109-a947822064b7a8077b15596c85bd9303@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/id-50009109-a947822064b7a8077b15596c85bd9303@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Sepatu Wanita"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/eb7d583e4b72085e71cd21a70ce47d7a@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/eb7d583e4b72085e71cd21a70ce47d7a@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Kesehatan"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/id-50009109-da8cea4e4705abb4dd935b244668e9dd@resize_w320_nl.webp",
        //     imageData:{url: "assets/images/brand_temp/id-50009109-da8cea4e4705abb4dd935b244668e9dd@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Tas Wanita"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/42394b78fac1169d67c6291973a3b132@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/42394b78fac1169d67c6291973a3b132@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Hobi & Koleksi"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/27838b968afb76ca59dd8e8f57ece91f@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/27838b968afb76ca59dd8e8f57ece91f@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Otomotif"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/b2c24b49fd96704ed80b4f45080bfcac@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/b2c24b49fd96704ed80b4f45080bfcac@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "OlahRaga & Outdoor"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/9251edd6d6dd98855ff5a99497835d9c@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/9251edd6d6dd98855ff5a99497835d9c@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Fashion Bayi & Anak"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/998c7682fd5e7a3563b2ad00aaa4e6f3@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/998c7682fd5e7a3563b2ad00aaa4e6f3@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Buku & Alat Tulis"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/id-50009109-28b537029726a804da60f448c9083298@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/id-50009109-28b537029726a804da60f448c9083298@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Souvenir & Perlengkapan"
        // },
        // {
        //     id: "",
        //     image: "assets/images/brand_temp/9abe95c0c755968c5114f084ee11b8cb@resize_w320_nl.webp",
        //     imageData: {url:"assets/images/brand_temp/9abe95c0c755968c5114f084ee11b8cb@resize_w320_nl.webp"},
        //     isActive: true,
        //     name: "Fotografi"
        // },
        // // {
        // //     id: "",
        // //     image: "assets/images/brand_temp/6e47e2193202b93490bc430ce6732c79@resize_w320_nl.webp",
        // //     imageData: {url:"assets/images/brand_temp/6e47e2193202b93490bc430ce6732c79@resize_w320_nl.webp"},
        // //     isActive: true,
        // //     name: "Voucher"
        // // },
        // // {
        // //     id: "",
        // //     image: "assets/images/brand_temp/acf31361b27aab4f75735c17d0eeace9@resize_w320_nl.webp",
        // //     imageData: {url:"assets/images/brand_temp/acf31361b27aab4f75735c17d0eeace9@resize_w320_nl.webp"},
        // //     isActive: true,
        // //     name: "Deals disekitarmu"
        // // } 

          {
            id: "",
            image: "assets/images/brand_temp/woman apparel.png",
            imageData:{url:"assets/images/brand_temp/woman apparel.png"} ,
            isActive: true,
            name: "Woman's Apparel"
        },
        {
            id: "",
            image: "assets/images/brand_temp/man apparel.png",
            imageData:{url:"assets/images/brand_temp/man apparel.png"} ,
            isActive: true,
            name: "Man's Apparel"
        },
        {
            id: "",
            image: "assets/images/brand_temp/woman bag and shoes.png",
            imageData:{url:"assets/images/brand_temp/woman bag and shoes.png"} ,
            isActive: true,
            name: "Woman's Bags, Shoes"
        },
        {
            id: "",
            image: "assets/images/brand_temp/mans bag and shoes.png",
            imageData:{url:"assets/images/brand_temp/mans bag and shoes.png"} ,
            isActive: true,
            name: "Man's Bags , Shoes"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Accessories & Jeweleries.png",
            imageData:{url:"assets/images/brand_temp/Accessories & Jeweleries.png"} ,
            isActive: true,
            name: "⁠Accessories & Jeweleries"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Watches.png",
            imageData:{url:"assets/images/brand_temp/Watches.png"} ,
            isActive: true,
            name: "Watches"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Mobile & Gadgets.png",
            imageData:{url:"assets/images/brand_temp/Mobile & Gadgets.png"} ,
            isActive: true,
            name: "Mobile & Gadgets"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Computers & Electronics.png",
            imageData:{url:"assets/images/brand_temp/Computers & Electronics.png"} ,
            isActive: true,
            name: "Computers & Electronics"
        },
         {
            id: "",
            image: "assets/images/brand_temp/Home Appliances.png",
            imageData:{url:"assets/images/brand_temp/Home Appliances.png"} ,
            isActive: true,
            name: "Home Appliances"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Home & Living.png",
            imageData:{url:"assets/images/brand_temp/Home & Living.png"} ,
            isActive: true,
            name: "Home & Living"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Hobbies.png",
            imageData:{url:"assets/images/brand_temp/Hobbies.png"} ,
            isActive: true,
            name: "Hobbies"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Sports & Outdoor.png",
            imageData:{url:"assets/images/brand_temp/Sports & Outdoor.png"} ,
            isActive: true,
            name: "⁠Sports & Outdoor"
        },
         {
            id: "",
            image: "assets/images/brand_temp/Beauty & Personal Care.png",
            imageData:{url:"assets/images/brand_temp/Beauty & Personal Care.png"} ,
            isActive: true,
            name: "Beauty & Personal Care"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Health & Wealth.png",
            imageData:{url:"assets/images/brand_temp/Health & Wealth.png"} ,
            isActive: true,
            name: "⁠Health & Wealth"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Packaging & Printing.png",
            imageData:{url:"assets/images/brand_temp/Packaging & Printing.png"} ,
            isActive: true,
            name: "Packaging & Printing"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Kids Apparel.png",
            imageData:{url:"assets/images/brand_temp/Kids Apparel.png"} ,
            isActive: true,
            name: "⁠Kids Apparel"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Toys & Babies.png",
            imageData:{url:"assets/images/brand_temp/Toys & Babies.png"} ,
            isActive: true,
            name: "Toys & Babies"
        },
         {
            id: "",
            image: "assets/images/brand_temp/Pets Supplies.png",
            imageData:{url:"assets/images/brand_temp/Pets Supplies.png"} ,
            isActive: true,
            name: "Pets Supplies"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Auto Parts & Automotive.png",
            imageData:{url:"assets/images/brand_temp/Auto Parts & Automotive.png"} ,
            isActive: true,
            name: "⁠Auto Parts & Automotive"
        },
         {
            id: "",
            image: "assets/images/brand_temp/Dining & Stay.png",
            imageData:{url:"assets/images/brand_temp/Dining & Stay.png"} ,
            isActive: true,
            name: "Dining & Stay"
        },
        {
            id: "",
            image: "assets/images/brand_temp/⁠Luggage & Travel.png",
            imageData:{url:"assets/images/brand_temp/Luggage & Travel.png"} ,
            isActive: true,
            name: "⁠Luggage & Travel"
        },
        {
            id: "",
            image: "assets/images/brand_temp/_Food & Beverages Supplies.png",
            imageData:{url:"assets/images/brand_temp/_Food & Beverages Supplies.png"} ,
            isActive: true,
            name: "Food & Beverages Supplies"
        },
         {
            id: "",
            image: "assets/images/brand_temp/_Services.png",
            imageData:{url:"assets/images/brand_temp/_Services.png"} ,
            isActive: true,
            name: "Services"
        },
         {
            id: "",
            image: "assets/images/brand_temp/Miscellaneous.png",
            imageData:{url:"assets/images/brand_temp/Miscellaneous.png"} ,
            isActive: true,
            name: "Miscellaneous"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Construction & Building.png",
            imageData:{url:"assets/images/brand_temp/Construction & Building.png"} ,
            isActive: true,
            name: "Construction & Building"
        },
        {
            id: "",
            image: "assets/images/brand_temp/_Machinery.png",
            imageData:{url:"assets/images/brand_temp/_Machinery.png"} ,
            isActive: true,
            name: "Machinery"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Real Estate & Building.png",
            imageData:{url:"assets/images/brand_temp/Real Estate & Building.png"} ,
            isActive: true,
            name: "Real Estate & Building"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Lights & Electrical.png",
            imageData:{url:"assets/images/brand_temp/Lights & Electrical.png"} ,
            isActive: true,
            name: "Lights & Electrical"
        },
         {
            id: "",
            image: "assets/images/brand_temp/Furniture.png",
            imageData:{url:"assets/images/brand_temp/Furniture.png"} ,
            isActive: true,
            name: "Furniture"
        },
         {
            id: "",
            image: "assets/images/brand_temp/Tools & Hardware.png",
            imageData:{url:"assets/images/brand_temp/Tools & Hardware.png"} ,
            isActive: true,
            name: "Tools & Hardware"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Agriculture & Raw Material.png",
            imageData:{url:"assets/images/brand_temp/Agriculture & Raw Material.png"} ,
            isActive: true,
            name: "Agriculture & Raw Material"
        },
    ]

    if (!StaticProductCategory || StaticProductCategory.length === 0) return null;
      // 1️⃣ Take the first item for Slide #1 (bottom position)
        const [firstItem, ...rest] = StaticProductCategory;

        // 2️⃣ Chunk the remaining items in pairs (top + bottom)
         const pairs = chunk(rest, 2);
        // const pairs = chunk(rest, 0);


    const SampleNextArrow = memo((props) => {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    });
    
    const SamplePrevArrow = memo((props) => {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    });
            
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 8,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: false,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                },
            },

        ],
    };

    return (
        
        <section className="recommended mt-40">
            <div className="container container-md">
                <div className="feature-item-wrapper">
                    {/* <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/all-product.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="" style={{ fontSize: "1rem"}}>
                                    ALL CATEGORY
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div> */}
                    {
                        // Array.isArray(productCategory) &&
                        // productCategory.length > 0 && (

                        // Array.isArray(pairs) &&
                        // pairs.length > 0 && (
                        Array.isArray(StaticProductCategory) &&
                        StaticProductCategory.length > 0 && (
                            <Slider {...settings}>

                                    {/* {
                                        
                                        <div key={0}>
                                            <div className="feature-item text-center mb-10">
                                                <div className="feature-item__thumb all rounded-circle">
                                                    <Link to="/products" className="w-100 h-100 flex-center">
                                                        <img src="assets/images/icon/all-product.png" alt="" />
                                                    </Link>
                                                </div>
                                                <div className="feature-item__content mt-16">
                                                    <h6 className="feature-item__title mb-8">
                                                        <Link to="/products" className="" style={{ fontSize: "14px"}}>
                                                            ALL CATEGORY
                                                        </Link>
                                                    </h6>
                                                    <span className="feature-item__desc text-gray-400">125+ Products</span>
                                                </div>
                                            </div>
                                        
                                            <div className="feature-item text-center mb-10" key={0}>
                                                <div className="feature-item__thumb rounded-circle">
                                                    <Link to={`/products?category=${firstItem.id}`} className="w-100 h-100 flex-center">
                                                        <img style={{ maxWidth: "70%" }} src={firstItem.imageData?.url || "assets/images/no-image.png"} alt="" />
                                                    </Link>
                                                </div>
                                                <div className="feature-item__content mt-16">
                                                    <h6 className="feature-item__title mb-8">
                                                        <Link to={`/products?category=${firstItem.id}`} className="" style={{ fontSize: "14px"}}>
                                                            {firstItem.name}
                                                        </Link>
                                                    </h6>
                                                    <span className="feature-item__desc text-gray-400">125+ Products</span>
                                                </div>
                                            </div> 
                                        </div>
                                        
                                    }
                                    
                            {
                                
                                // productCategory.map((item, index) => (
                                pairs.map((item, index) => (
                                   
                                    <div key={index + 1}> 
                                       
                                        {
                                            item[0] != undefined && (
                                            <div className="feature-item text-center mb-10" >
                                                <div className="feature-item__thumb rounded-circle">
                                                    <Link to={`/products?category=${item[0].id}`} className="w-100 h-100 flex-center">
                                                        <img style={{ maxWidth: "70%" }} src={item[0].imageData?.url || "assets/images/no-image.png"} alt="" />
                                                    </Link>
                                                </div>
                                                <div className="feature-item__content mt-16">
                                                    <h6 className="feature-item__title mb-8">
                                                        <Link to={`/products?category=${item[0].id}`} className="" style={{ fontSize: "14px"}}>
                                                            {item[0].name}
                                                        </Link>
                                                    </h6>
                                                    <span className="feature-item__desc text-gray-400">125+ Products</span>
                                                </div>
                                            </div>
                                            )
                                        }
                                        
                                        {
                                            item.length > 1 && (
                                                <div className="feature-item text-center mb-10" >
                                                    <div className="feature-item__thumb rounded-circle">
                                                        <Link to={`/products?category=${item.id}`} className="w-100 h-100 flex-center">
                                                            <img style={{ maxWidth: "70%" }} src={item[1].imageData?.url || "assets/images/no-image.png"} alt="" />
                                                        </Link>
                                                    </div>
                                                    <div className="feature-item__content mt-16">
                                                        <h6 className="feature-item__title mb-5">
                                                            <Link to={`/products?category=${item[1].id}`} className="" style={{ fontSize: "14px"}}>
                                                                {item[1].name}
                                                            </Link>
                                                        </h6>
                                                        <span className="feature-item__desc text-gray-400">125+ Products</span>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        
                                    </div>

                                    
                                ))
                            } */}



                            {
                                StaticProductCategory.map((item, index) => (
                                    pairs.map((item, index) => (
                                    <div key={index + 1}> 
                                        
                                            {
                                               
                                                item[0] != undefined && (
                                                <div className="feature-item text-center mb-20" >
                                                    <div className="feature-item__thumb rounded-circle">
                                                        <Link to={`/products?category=${item[0].id}`} className="w-100 h-100 flex-center">
                                                            <img style={{ maxWidth: "100%" }} src={item[0].imageData?.url || "assets/images/no-image.png"} alt="" />
                                                        </Link>
                                                    </div>
                                                    <div className="feature-item__content mt-16">
                                                        <h6 className="feature-item__title mb-8">
                                                            <Link to={`/products?category=${item[0].id}`} className="" style={{ fontSize: "14px"}}>
                                                                {item[0].name}
                                                            </Link>
                                                        </h6>
                                                    </div>
                                                </div>
                                                )
                                            }
                                            
                                            {
                                                item.length > 1 && (
                                                    <div className="feature-item text-center mb-20" >
                                                        <div className="feature-item__thumb rounded-circle">
                                                            <Link to={`/products?category=${item.id}`} className="w-100 h-100 flex-center">
                                                                <img style={{ maxWidth: "100%" }} src={item[1].imageData?.url || "assets/images/no-image.png"} alt="" />
                                                            </Link>
                                                        </div>
                                                        <div className="feature-item__content mt-16">
                                                            <h6 className="feature-item__title mb-5">
                                                                <Link to={`/products?category=${item[1].id}`} className="" style={{ fontSize: "14px"}}>
                                                                    {item[1].name}
                                                                </Link>
                                                            </h6>
                                                        
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            
                                        </div>
                                    
                                    ))


                                   
                                )) 
                            }
                            </Slider>
                        )
                    }
                    
                    
                    {/* <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/drink-beverages.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Drinks & Beverages
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/all-time-pastry.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    All Time Pastry
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/health-wellness.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Health & Wellness
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/baby-child.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Baby & Child
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/baking-needs.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Baking Needs
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/breakfast.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Breakfast & Cereal
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/canned-food.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Canned Foods
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/chillie.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Chili Sauce & Condiments
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/cooking-ingridient.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Cooking Ingridients
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/cracker-snack.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Cracker Snack & Cookies
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/dairy-product.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Dairy Products
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/dried-food.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Dried Food
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/frozen-food.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Frozen Food & Fresh Food
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/milk-powder.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Milk Powder
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/seasonal-food.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Seasonal Speciality Food
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>

    )
}

export default CategoryListHome